<script setup lang="ts">
import { useCountdown } from "@vueuse/core";

const props = defineProps<{ timestamp: number }>();

const initialCountdown = ref((props.timestamp - Date.now()) / 1000);
const { remaining } = useCountdown(initialCountdown, { immediate: true });
const r = computed(() => ({
  days: Math.floor(remaining.value / 86400),
  hours: String(Math.floor((remaining.value % 86400) / 3600)).padStart(2, "0"),
  minutes: String(Math.floor((remaining.value % 3600) / 60)).padStart(2, "0"),
  seconds: String(Math.floor(remaining.value % 60)).padStart(2, "0"),
}));
</script>

<template>
  <div v-if="remaining > 0" class="grid auto-cols-auto grid-flow-col gap-2 text-center text-xs">
    <div class="flex flex-col rounded-lg bg-light p-2">
      <span class="font-mono text-5xl font-bold">
        {{ r.days }}
      </span>
      {{ r.days > 1 ? "jours" : "jour" }}
    </div>
    <div class="flex flex-col rounded-lg bg-light p-2">
      <span class="font-mono text-5xl font-bold">
        {{ r.hours }}
      </span>
      heures
    </div>
    <div class="flex flex-col rounded-lg bg-light p-2">
      <span class="font-mono text-5xl font-bold">
        {{ r.minutes }}
      </span>
      minutes
    </div>
    <div class="flex flex-col rounded-lg bg-light p-2">
      <span class="font-mono text-5xl font-bold">
        {{ r.seconds }}
      </span>
      secondes
    </div>
  </div>
</template>
